import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=34c4eaee&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=34c4eaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4eaee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c4eaee')) {
      api.createRecord('34c4eaee', component.options)
    } else {
      api.reload('34c4eaee', component.options)
    }
    module.hot.accept("./DragAndDrop.vue?vue&type=template&id=34c4eaee&scoped=true&", function () {
      api.rerender('34c4eaee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/components/DragAndDrop.vue"
export default component.exports